import React, { createContext, useContext, useState, useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { default as useAuth } from "./useAuth"
import { api, queryTools, OPERATORS } from "lib/utils"


interface IAppTools {
  resource: any
}

// Create a Context with a placeholder type
const AppContext = createContext({ appState: {} });
export const useAppCtx = () => useContext(AppContext)

export function AppProvider({children}:{children:React.ReactNode}) {

  const generateDispute = (args:any, callback?:any) => {
    const { dispute, rp, subdomain } = args
    const { data } = useQuery({ 
      queryKey: ["disputeById", dispute, rp, subdomain ], 
      queryFn: async () => {
        const result = await fetch(`/api/composite?dspid=${dispute}&rp=${rp}&subdomain=${subdomain}`)
        const data = await result.json()
        if( data.result !== "success" ) throw new Error(data.msg)
        if( callback ) callback(data)
      },
      enabled: !!(dispute && rp && subdomain)
    })
    return data
  }


  const [ appState, setAppState ] = useState<any>({ queries: { generateDispute } })
  const { user } = useAuth( appState )

  useEffect(() => {
    console.log(user)
    if( user ) setAppState((prev:any) => ({ ...prev, user: user }))
  },[user])

  return (
    <AppContext.Provider value={{ appState }}>
      {children}
    </AppContext.Provider>
  )
}
